// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet";
// import styled from 'styled-components';
// import { ArrowLeft, ArrowRight, RotateCcw } from 'lucide-react';
// import axios from 'axios';
// import storage from '../../../Storage';

// import { getUID } from '../../../Helper';

// const Container = styled.div`
//   min-height: 100vh;
//   background: #03030F;
//   color: white;
//   padding: 0;
// `;

// const Header = styled.div`
//   display: flex;
//   align-items: center;
//   margin-bottom: 20px;
//   padding: 20px 20px 0 20px;
// `;

// const Title = styled.h1`
//   font-size: 24px;
//   font-weight: bold;
//   color: white;
//   margin: 0;
// `;

// const TabContainer = styled.div`
//   display: flex;
//   margin-bottom: 20px;
//   padding: 0 20px;
//   border-bottom: 1px solid rgba(255, 255, 255, 0.1);
// `;

// const Tab = styled.button`
//   background: none;
//   border: none;
//   color: ${props => props.active ? '#FF5C5C' : '#BCC7CB'};
//   font-size: 16px;
//   font-weight: 500;
//   padding: 12px 0;
//   margin-right: 40px;
//   cursor: pointer;
//   position: relative;
//   transition: color 0.3s ease;

//   &:hover {
//     color: #FF5C5C;
//   }

//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -1px;
//     left: 0;
//     right: 0;
//     height: 2px;
//     background: ${props => props.active ? '#FF5C5C' : 'transparent'};
//     transition: background 0.3s ease;
//   }
// `;

// const ContentArea = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   min-height: 500px;
//   padding: 60px 20px;
// `;

// const IconContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: 30px;
//   position: relative;
//   gap: 20px;
// `;

// const BoxIcon = styled.div`
//   width: 80px;
//   height: 60px;
//   border: 2px solid #FF5C5C;
//   border-radius: 8px;
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: center;
  
//   &::before {
//     content: '';
//     position: absolute;
//     width: 40px;
//     height: 2px;
//     background: #FF5C5C;
//     border-radius: 1px;
//   }

//   @media (max-width: 768px) {
//     width: 60px;
//     height: 45px;
    
//     &::before {
//       width: 30px;
//       height: 1.5px;
//     }
//   }
// `;

// const LeftBox = styled(BoxIcon)`
//   &::before {
//     width: 30px;
//     height: 2px;
//     background: #FF5C5C;
//     border-radius: 1px;
//     transform: rotate(-15deg);
//   }

//   @media (max-width: 768px) {
//     &::before {
//       width: 22px;
//       height: 1.5px;
//     }
//   }
// `;

// const RightBox = styled(BoxIcon)`
//   &::before {
//     width: 40px;
//     height: 2px;
//     background: #FF5C5C;
//     border-radius: 1px;
//   }

//   @media (max-width: 768px) {
//     &::before {
//       width: 30px;
//       height: 1.5px;
//     }
//   }
// `;

// const ConnectingArc = styled.div`
//   position: absolute;
//   bottom: -10px;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 60px;
//   height: 30px;
//   border: 2px solid #FF5C5C;
//   border-top: none;
//   border-radius: 0 0 60px 60px;

//   @media (max-width: 768px) {
//     width: 45px;
//     height: 22px;
//     border-width: 1.5px;
//     border-radius: 0 0 45px 45px;
//   }
// `;

// const NoDataText = styled.div`
//   font-size: 18px;
//   color: white;
//   font-weight: 500;
//   margin-top: 10px;
// `;

// const StatsContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 20px;
//   margin-top: 40px;
//   width: 100%;
//   max-width: 800px;
// `;

// const StatCard = styled.div`
//   background: rgba(30, 35, 40, 0.9);
//   border-radius: 16px;
//   padding: 24px;
//   text-align: center;
//   border: 1px solid rgba(76, 175, 80, 0.3);
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   transition: all 0.3s ease;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
//     border-color: rgba(76, 175, 80, 0.5);
//   }
// `;

// const StatLabel = styled.div`
//   font-size: 14px;
//   color: #BCC7CB;
//   margin-bottom: 12px;
//   font-weight: 500;
//   text-transform: uppercase;
//   letter-spacing: 0.5px;
// `;

// const StatValue = styled.div`
//   font-size: 28px;
//   font-weight: bold;
//   color: #FF5C5C;
//   text-shadow: 0 2px 4px rgba(76, 175, 80, 0.3);
// `;

// const FilterContainer = styled.div`
//   display: flex;
//   gap: 12px;
//   margin-bottom: 30px;
//   padding: 0 20px;
// `;

// const FilterButton = styled.button`
//   background: ${props => props.active ? '#FF5C5C' : 'rgba(30, 35, 40, 0.9)'};
//   border: 1px solid ${props => props.active ? '#FF5C5C' : 'rgba(255, 255, 255, 0.1)'};
//   color: white;
//   padding: 10px 20px;
//   border-radius: 25px;
//   font-size: 14px;
//   font-weight: 500;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   box-shadow: ${props => props.active ? '0 2px 8px rgba(76, 175, 80, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.2)'};

//   &:hover {
//     background: ${props => props.active ? '#FF5C5C' : 'rgba(76, 175, 80, 0.1)'};
//     border-color: #FF5C5C;
//     transform: translateY(-1px);
//   }

//   @media (max-width: 768px) {
//     padding: 8px 16px;
//     font-size: 12px;
//   }
// `;

// /* --- NEW: Wager table styles --- */
// const WagerTableWrapper = styled.div`
//   width: 100%;
//   max-width: 900px;
//   padding: 0 20px;
//   margin-bottom: 20px;
// `;

// const WagerTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   background: rgba(30,35,40,0.9);
//   border-radius: 12px;
//   overflow: hidden;
//   border: 1px solid rgba(255,255,255,0.04);
// `;

// const WagerTHead = styled.thead`
//   background: rgba(255,255,255,0.02);
// `;

// const WagerTH = styled.th`
//   text-align: left;
//   padding: 12px 16px;
//   color: #BCC7CB;
//   font-size: 13px;
//   font-weight: 600;
// `;

// const WagerTD = styled.td`
//   padding: 12px 16px;
//   color: #fff;
//   font-size: 15px;
//   border-top: 1px solid rgba(255,255,255,0.03);
// `;

// const ProgressTrack = styled.div`
//   height: 10px;
//   background: #222629;
//   border-radius: 999px;
//   overflow: hidden;
// `;

// const ProgressFill = styled.div`
//   height: 100%;
//   width: ${props => props.pct}%;
//   transition: width 400ms cubic-bezier(.22,.9,.34,1);
//   background: linear-gradient(90deg, #FFD54F, #FFB300);
// `;

// /* -------------------- Component -------------------- */

// const Turnover = () => {
//   const [activeTab, setActiveTab] = useState('active');
//   const [timeFilter, setTimeFilter] = useState('all');
//   const [turnoverData, setTurnoverData] = useState({
//     active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
//     completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 }
//   });

//   // NEW: wager state
//   const [wagerInfo, setWagerInfo] = useState({ wager: 0, required: 0, eligible: false });
//   const [loadingWager, setLoadingWager] = useState(true);

//   const timeFilters = [
//     { key: 'all', label: 'All Time' },
//     { key: 'today', label: 'Today' },
//     { key: 'week', label: 'This Week' },
//     { key: 'month', label: 'This Month' }
//   ];

//   useEffect(() => {
//     // Simulate data loading for turnover (keep your existing logic)
//     setTurnoverData({
//       active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
//       completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 }
//     });

//     // Fetch wager eligibility/details directly via axios
//     const fetchWager = async () => {
//       setLoadingWager(true);
//       try {
//         const uid = getUID ? getUID() : null;
//         const token = storage.getKey('token');
//         if (!uid || !token) {
//           setWagerInfo({ wager: 0, required: 0, eligible: false });
//         } else {
//           const url = `https://api.ibitplay.com/check-wager/${uid}`;
//           const res = await axios.get(url, {
//             headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
//           });
//           const data = res.data || {};
//           setWagerInfo({
//             wager: Number(data.wager || 0),
//             required: Number(data.required || 0),
//             eligible: Boolean(data.eligible)
//           });
//         }
//       } catch (err) {
//         console.error('Failed to fetch wager info', err);
//         setWagerInfo({ wager: 0, required: 0, eligible: false });
//       } finally {
//         setLoadingWager(false);
//       }
//     };

//     fetchWager();
//   }, []);

//   const getCurrentData = () => turnoverData[activeTab];

//   const hasData = () => {
//     const data = getCurrentData();
//     return data.total > 0 || data.today > 0 || data.thisWeek > 0 || data.thisMonth > 0;
//   };

//   // compute progress %
//   const computeProgressPct = () => {
//     const w = Number(wagerInfo.wager || 0);
//     const r = Number(wagerInfo.required || 0);
//     if (r <= 0) return 0;
//     return Math.min(100, Math.round((w / r) * 100));
//   };

//   return (
//     <Container>
//       <Helmet>
//         <title>Turnover - Crypto Casino Games</title>
//         <meta name="description" content="Track your turnover and betting activity" />
//       </Helmet>

//       <Header>
//         <Title>Turnover</Title>
//       </Header>

//       <TabContainer>
//         <Tab active={activeTab === 'active'} onClick={() => setActiveTab('active')}>Active</Tab>
//         <Tab active={activeTab === 'completed'} onClick={() => setActiveTab('completed')}>Completed</Tab>
//       </TabContainer>

//       <FilterContainer>
//         {timeFilters.map(filter => (
//           <FilterButton key={filter.key} active={timeFilter === filter.key} onClick={() => setTimeFilter(filter.key)}>
//             {filter.label}
//           </FilterButton>
//         ))}
//       </FilterContainer>

//       {/* NEW: Wager info table */}
//       <WagerTableWrapper>
//         <WagerTable>
//           <WagerTHead>
//             <tr>
//               <WagerTH>Wager Metric</WagerTH>
//               <WagerTH>Value</WagerTH>
//               <WagerTH style={{ width: 240, textAlign: 'center' }}>Progress</WagerTH>
//             </tr>
//           </WagerTHead>
//           <tbody>
//             <tr>
//               <WagerTD>Current Wager</WagerTD>
//               <WagerTD>{loadingWager ? 'Loading…' : wagerInfo.wager.toLocaleString()}</WagerTD>
//               <WagerTD rowSpan={2} style={{ verticalAlign: 'middle' }}>
//                 <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12 }}>
//                   <div style={{ flex: 1 }}>
//                     <ProgressTrack>
//                       <ProgressFill pct={computeProgressPct()} />
//                     </ProgressTrack>
//                   </div>
//                   <div style={{ minWidth: 48, textAlign: 'right', color: '#fff', fontWeight: 700 }}>
//                     {computeProgressPct()}%
//                   </div>
//                 </div>
//               </WagerTD>
//             </tr>

//             <tr>
//               <WagerTD>Required Wager</WagerTD>
//               <WagerTD>{loadingWager ? '—' : wagerInfo.required.toLocaleString()}</WagerTD>
//             </tr>
//           </tbody>
//         </WagerTable>
//       </WagerTableWrapper>

//       <ContentArea>
//         {!hasData() ? (
//           <>
//             <IconContainer>
//               <LeftBox />
//               <RightBox />
//               <ConnectingArc />
//             </IconContainer>
//             <NoDataText>No data</NoDataText>
//           </>
//         ) : (
//           <StatsContainer>
//             <StatCard>
//               <StatLabel>Total Turnover</StatLabel>
//               <StatValue>{getCurrentData().total.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>Today</StatLabel>
//               <StatValue>{getCurrentData().today.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>This Week</StatLabel>
//               <StatValue>{getCurrentData().thisWeek.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>This Month</StatLabel>
//               <StatValue>{getCurrentData().thisMonth.toLocaleString()}</StatValue>
//             </StatCard>
//           </StatsContainer>
//         )}
//       </ContentArea>
//     </Container>
//   );
// };

// export default Turnover;

//=====================================================================================================

// import React, { useState, useEffect } from "react";
// import { Helmet } from "react-helmet";
// import styled from 'styled-components';
// import { ArrowLeft, ArrowRight, RotateCcw } from 'lucide-react';
// import axios from 'axios';
// import storage from '../../../Storage';
// import { getUID } from '../../../Helper';

// // ──────────────────────────────────────────────────────────────
// //  STYLES (Same as before)
// // ──────────────────────────────────────────────────────────────
// const Container = styled.div`
//   min-height: 100vh;
//   background: #03030F;
//   color: white;
//   padding: 0;
// `;

// const Header = styled.div`
//   display: flex;
//   align-items: center;
//   margin-bottom: 20px;
//   padding: 20px 20px 0 20px;
// `;

// const Title = styled.h1`
//   font-size: 24px;
//   font-weight: bold;
//   color: white;
//   margin: 0;
// `;

// const TabContainer = styled.div`
//   display: flex;
//   margin-bottom: 20px;
//   padding: 0 20px;
//   border-bottom: 1px solid rgba(255, 255, 255, 0.1);
// `;

// const Tab = styled.button`
//   background: none;
//   border: none;
//   color: ${props => props.active ? '#FF5C5C' : '#BCC7CB'};
//   font-size: 16px;
//   font-weight: 500;
//   padding: 12px 0;
//   margin-right: 40px;
//   cursor: pointer;
//   position: relative;
//   transition: color 0.3s ease;

//   &:hover { color: #FF5C5C; }

//   &::after {
//     content: '';
//     position: absolute;
//     bottom: -1px;
//     left: 0;
//     right: 0;
//     height: 2px;
//     background: ${props => props.active ? '#FF5C5C' : 'transparent'};
//     transition: background 0.3s ease;
//   }
// `;

// const ContentArea = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   min-height: 500px;
//   padding: 60px 20px;
// `;

// const IconContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-bottom: 30px;
//   position: relative;
//   gap: 20px;
// `;

// const BoxIcon = styled.div`
//   width: 80px;
//   height: 60px;
//   border: 2px solid #FF5C5C;
//   border-radius: 8px;
//   position: relative;
//   display: flex;
//   align-items: center;
//   justify-content: center;
  
//   &::before {
//     content: '';
//     position: absolute;
//     width: 40px;
//     height: 2px;
//     background: #FF5C5C;
//     border-radius: 1px;
//   }

//   @media (max-width: 768px) {
//     width: 60px;
//     height: 45px;
//     &::before { width: 30px; height: 1.5px; }
//   }
// `;

// const LeftBox = styled(BoxIcon)`
//   &::before { transform: rotate(-15deg); }
// `;

// const RightBox = styled(BoxIcon)``;

// const ConnectingArc = styled.div`
//   position: absolute;
//   bottom: -10px;
//   left: 50%;
//   transform: translateX(-50%);
//   width: 60px;
//   height: 30px;
//   border: 2px solid #FF5C5C;
//   border-top: none;
//   border-radius: 0 0 60px 60px;

//   @media (max-width: 768px) {
//     width: 45px;
//     height: 22px;
//     border-width: 1.5px;
//     border-radius: 0 0 45px 45px;
//   }
// `;

// const NoDataText = styled.div`
//   font-size: 18px;
//   color: white;
//   font-weight: 500;
//   margin-top: 10px;
// `;

// const StatsContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
//   gap: 20px;
//   margin-top: 40px;
//   width: 100%;
//   max-width: 800px;
// `;

// const StatCard = styled.div`
//   background: rgba(30, 35, 40, 0.9);
//   border-radius: 16px;
//   padding: 24px;
//   text-align: center;
//   border: 1px solid rgba(76, 175, 80, 0.3);
//   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//   transition: all 0.3s ease;

//   &:hover {
//     transform: translateY(-2px);
//     box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
//     border-color: rgba(76, 175, 80, 0.5);
//   }
// `;

// const StatLabel = styled.div`
//   font-size: 14px;
//   color: #BCC7CB;
//   margin-bottom: 12px;
//   font-weight: 500;
//   text-transform: uppercase;
//   letter-spacing: 0.5px;
// `;

// const StatValue = styled.div`
//   font-size: 28px;
//   font-weight: bold;
//   color: #FF5C5C;
//   text-shadow: 0 2px 4px rgba(76, 175, 80, 0.3);
// `;

// const FilterContainer = styled.div`
//   display: flex;
//   gap: 12px;
//   margin-bottom: 30px;
//   padding: 0 20px;
// `;

// const FilterButton = styled.button`
//   background: ${props => props.active ? '#FF5C5C' : 'rgba(30, 35, 40, 0.9)'};
//   border: 1px solid ${props => props.active ? '#FF5C5C' : 'rgba(255, 255, 255, 0.1)'};
//   color: white;
//   padding: 10px 20px;
//   border-radius: 25px;
//   font-size: 14px;
//   font-weight: 500;
//   cursor: pointer;
//   transition: all 0.3s ease;
//   box-shadow: ${props => props.active ? '0 2px 8px rgba(76, 175, 80, 0.3)' : '0 2px 4px rgba(0, 0, 0, 0.2)'};

//   &:hover {
//     background: ${props => props.active ? '#FF5C5C' : 'rgba(76, 175, 80, 0.1)'};
//     border-color: #FF5C5C;
//     transform: translateY(-1px);
//   }

//   @media (max-width: 768px) {
//     padding: 8px 16px;
//     font-size: 12px;
//   }
// `;

// // ──────────────────────────────────────────────────────────────
// //  Wager Table Styles
// // ──────────────────────────────────────────────────────────────
// const WagerTableWrapper = styled.div`
//   width: 100%;
//   max-width: 900px;
//   padding: 0 20px;
//   margin-bottom: 20px;
// `;

// const WagerTable = styled.table`
//   width: 100%;
//   border-collapse: collapse;
//   background: rgba(30,35,40,0.9);
//   border-radius: 12px;
//   overflow: hidden;
//   border: 1px solid rgba(255,255,255,0.04);
// `;

// const WagerTHead = styled.thead`
//   background: rgba(255,255,255,0.02);
// `;

// const WagerTH = styled.th`
//   text-align: left;
//   padding: 12px 16px;
//   color: #BCC7CB;
//   font-size: 13px;
//   font-weight: 600;
// `;

// const WagerTD = styled.td`
//   padding: 12px 16px;
//   color: #fff;
//   font-size: 15px;
//   border-top: 1px solid rgba(255,255,255,0.03);
// `;

// const ProgressTrack = styled.div`
//   height: 10px;
//   background: #222629;
//   border-radius: 999px;
//   overflow: hidden;
// `;

// const ProgressFill = styled.div`
//   height: 100%;
//   width: ${props => props.pct}%;
//   transition: width 400ms cubic-bezier(.22,.9,.34,1);
//   background: linear-gradient(90deg, #FFD54F, #FFB300);
// `;

// // ──────────────────────────────────────────────────────────────
// //  Component
// // ──────────────────────────────────────────────────────────────
// const Turnover = () => {
//   const [activeTab, setActiveTab] = useState('active');
//   const [timeFilter, setTimeFilter] = useState('all');
//   const [turnoverData, setTurnoverData] = useState({
//     active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
//     completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 }
//   });

//   // NEW: wager state (mapped from new API)
//   const [wagerInfo, setWagerInfo] = useState({
//     wager: 0,
//     total_deposit: 0,
//     target: 0,
//     percentage: 0,
//     eligible: false
//   });
//   const [loadingWager, setLoadingWager] = useState(true);

//   const timeFilters = [
//     { key: 'all', label: 'All Time' },
//     { key: 'today', label: 'Today' },
//     { key: 'week', label: 'This Week' },
//     { key: 'month', label: 'This Month' }
//   ];

//   useEffect(() => {
//     // Keep your existing turnover logic
//     setTurnoverData({
//       active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
//       completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 }
//     });

//     // Fetch wager data from NEW API
//     const fetchWager = async () => {
//       setLoadingWager(true);
//       try {
//         const uid = getUID ? getUID() : null;
//         const token = storage.getKey('token');
//         if (!uid || !token) {
//           setWagerInfo({ wager: 0, total_deposit: 0, target: 0, percentage: 0, eligible: false });
//         } else {
//           const url = `https://api.ibitplay.com/check-wager/${uid}`;
//           const res = await axios.get(url, {
//             headers: { 
//               'Content-Type': 'application/json', 
//               Authorization: `Bearer ${token}` 
//             }
//           });

//           const data = res.data || {};
//           setWagerInfo({
//             wager: Number(data.wager || 0),
//             total_deposit: Number(data.total_deposit || 0),
//             target: Number(data.target || 0),
//             percentage: Number(data.percentage || 0),
//             eligible: Boolean(data.eligible)
//           });
//         }
//       } catch (err) {
//         console.error('Failed to fetch wager info', err);
//         setWagerInfo({ wager: 0, total_deposit: 0, target: 0, percentage: 0, eligible: false });
//       } finally {
//         setLoadingWager(false);
//       }
//     };

//     fetchWager();
//   }, []);

//   const getCurrentData = () => turnoverData[activeTab];
//   const hasData = () => {
//     const data = getCurrentData();
//     return data.total > 0 || data.today > 0 || data.thisWeek > 0 || data.thisMonth > 0;
//   };

//   // Use backend percentage directly
//   const progressPct = Math.min(100, Math.round(wagerInfo.percentage));

//   return (
//     <Container>
//       <Helmet>
//         <title>Turnover - Crypto Casino Games</title>
//         <meta name="description" content="Track your turnover and betting activity" />
//       </Helmet>

//       <Header>
//         <Title>Turnover</Title>
//       </Header>

//       {/* <TabContainer>
//         <Tab active={activeTab === 'active'} onClick={() => setActiveTab('active')}>Active</Tab>
//         <Tab active={activeTab === 'completed'} onClick={() => setActiveTab('completed')}>Completed</Tab>
//       </TabContainer> */}

//       {/* <FilterContainer>
//         {timeFilters.map(filter => (
//           <FilterButton key={filter.key} active={timeFilter === filter.key} onClick={() => setTimeFilter(filter.key)}>
//             {filter.label}
//           </FilterButton>
//         ))}
//       </FilterContainer> */}

//       {/* WAGER TABLE (Updated) */}
//       <WagerTableWrapper>
//         <WagerTable>
//           <WagerTHead>
//             <tr>
//               <WagerTH>Wager Metric</WagerTH>
//               <WagerTH>Value</WagerTH>
//               <WagerTH style={{ width: 240, textAlign: 'center' }}>Progress</WagerTH>
//             </tr>
//           </WagerTHead>
//           <tbody>
//             <tr>
//               <WagerTD>Current Wager</WagerTD>
//               <WagerTD>
//                 {loadingWager ? 'Loading…' : wagerInfo.wager.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//               </WagerTD>
//               <WagerTD rowSpan={2} style={{ verticalAlign: 'middle' }}>
//                 <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 12 }}>
//                   <div style={{ flex: 1 }}>
//                     <ProgressTrack>
//                       <ProgressFill pct={progressPct} />
//                     </ProgressTrack>
//                   </div>
//                   <div style={{ minWidth: 48, textAlign: 'right', color: '#fff', fontWeight: 700 }}>
//                     {progressPct}%
//                   </div>
//                 </div>
//               </WagerTD>
//             </tr>

//             <tr>
//               <WagerTD>Required Wager </WagerTD>
//               <WagerTD>
//                 {loadingWager ? '—' : wagerInfo.target.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//               </WagerTD>
//             </tr>

//             <tr>
//               <WagerTD>Total Deposit</WagerTD>
//               <WagerTD colSpan={2}>
//                 {loadingWager ? '—' : wagerInfo.total_deposit.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//               </WagerTD>
//             </tr>
//           </tbody>
//         </WagerTable>
//       </WagerTableWrapper>

//       {/* Turnover Stats */}
//       <ContentArea>
//         {!hasData() ? (
//           <>
//             <IconContainer>
//               <LeftBox />
//               <RightBox />
//               <ConnectingArc />
//             </IconContainer>
//             <NoDataText>No data</NoDataText>
//           </>
//         ) : (
//           <StatsContainer>
//             <StatCard>
//               <StatLabel>Total Turnover</StatLabel>
//               <StatValue>{getCurrentData().total.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>Today</StatLabel>
//               <StatValue>{getCurrentData().today.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>This Week</StatLabel>
//               <StatValue>{getCurrentData().thisWeek.toLocaleString()}</StatValue>
//             </StatCard>
//             <StatCard>
//               <StatLabel>This Month</StatLabel>
//               <StatValue>{getCurrentData().thisMonth.toLocaleString()}</StatValue>
//             </StatCard>
//           </StatsContainer>
//         )}
//       </ContentArea>
//     </Container>
//   );
// };

// export default Turnover;


//===============================================

"use client"

import { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import { TrendingUp } from "lucide-react"
import axios from "axios"
import storage from '../../../Storage';
import { getUID } from '../../../Helper';

// ──────────────────────────────────────────────────────────────
//  MODERN STYLES WITH ANIMATIONS
// ──────────────────────────────────────────────────────────────

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(140deg, #03030F, red 0%, #0A0E03 29%);
  color: white;
  padding: 0;
  font-family: Montserrat Alternates;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 24px;
  border-bottom: 1px solid rgba(239, 68, 68, 0.1);
  background: rgba(10, 14, 39, 0.4);
  backdrop-filter: blur(10px);
  animation: slideDown 0.6s ease-out;

  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 24px 16px;
  }
`

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  letter-spacing: -0.5px;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const TitleIcon = styled.div`
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.8;
    }
  }
`

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 60px 24px;

  @media (max-width: 768px) {
    padding: 40px 16px;
  }
`

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  position: relative;
  gap: 20px;
  animation: fadeIn 0.8s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    gap: 12px;
  }
`

const BoxIcon = styled.div`
  width: 80px;
  height: 60px;
  border: 2px solid rgba(239, 68, 68, 0.6);
  border-radius: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(239, 68, 68, 0.05);
  animation: float 3s ease-in-out infinite;
  
  &::before {
    content: '';
    position: absolute;
    width: 40px;
    height: 2px;
    background: rgba(239, 68, 68, 0.8);
    border-radius: 1px;
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @media (max-width: 768px) {
    width: 60px;
    height: 45px;
    &::before { width: 30px; height: 1.5px; }
  }
`

const LeftBox = styled(BoxIcon)`
  &::before { transform: rotate(-15deg); }
  animation-delay: 0s;
`

const RightBox = styled(BoxIcon)`
  animation-delay: 0.2s;
`

const ConnectingArc = styled.div`
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 30px;
  border: 2px solid rgba(239, 68, 68, 0.6);
  border-top: none;
  border-radius: 0 0 60px 60px;
  background: rgba(239, 68, 68, 0.05);
  animation: fadeIn 0.8s ease-out 0.4s both;

  @media (max-width: 768px) {
    width: 45px;
    height: 22px;
    border-width: 1.5px;
    border-radius: 0 0 45px 45px;
  }
`

const NoDataText = styled.div`
  font-size: 18px;
  color: #cbd5e1;
  font-weight: 500;
  margin-top: 10px;
  letter-spacing: 0.3px;
`

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 40px;
  width: 100%;
  max-width: 1000px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 16px;
    margin-top: 30px;
  }
`

const StatCard = styled.div`
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.6) 100%);
  border-radius: 16px;
  padding: 28px 24px;
  text-align: center;
  border: 1px solid rgba(239, 68, 68, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  animation: slideUp 0.6s ease-out backwards;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(239, 68, 68, 0.5), transparent);
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(239, 68, 68, 0.15);
    border-color: rgba(239, 68, 68, 0.4);
  }

  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`

const StatLabel = styled.div`
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
`

const StatValue = styled.div`
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`

// ──────────────────────────────────────────────────────────────
//  Wager Table Styles (Modernized)
// ──────────────────────────────────────────────────────────────

const WagerTableWrapper = styled.div`
  width: 100%;
  max-width: 1000px;
  padding: 24px;
  margin-bottom: 20px;
  animation: slideUp 0.6s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 16px;
  }
`

const WagerTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.6) 100%);
  border-radius: 16px;
  overflow: hidden;
  border: 1px solid rgba(239, 68, 68, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  font-family: 'Montserrat Alternates', sans-serif;
`

const WagerTHead = styled.thead`
  background: linear-gradient(90deg, rgba(239, 68, 68, 0.1) 0%, rgba(220, 38, 38, 0.05) 100%);
  border-bottom: 1px solid rgba(239, 68, 68, 0.2);
`

const WagerTH = styled.th`
  text-align: left;
  padding: 16px 20px;
  color: #cbd5e1;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'Montserrat Alternates', sans-serif;

  @media (max-width: 768px) {
    padding: 12px 14px;
    font-size: 11px;
  }
`

const WagerTD = styled.td`
  padding: 16px 20px;
  color: #e2e8f0;
  font-size: 15px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  font-weight: 500;

  @media (max-width: 768px) {
    padding: 12px 14px;
    font-size: 13px;
  }
`

const ProgressTrack = styled.div`
  height: 12px;
  background: rgba(15, 23, 42, 0.6);
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid rgba(239, 68, 68, 0.2);
`

const ProgressFill = styled.div`
  height: 100%;
  width: ${(props) => props.pct}%;
  transition: width 500ms cubic-bezier(0.4, 0, 0.2, 1);
  background: linear-gradient(90deg, #ef4444 0%, #dc2626 100%);
  box-shadow: 0 0 12px rgba(239, 68, 68, 0.5);
  animation: fillProgress 1s ease-out;

  @keyframes fillProgress {
    from {
      width: 0;
    }
    to {
      width: ${(props) => props.pct}%;
    }
  }
`

const ProgressLabel = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #ef4444;
  text-align: right;
  min-width: 50px;
`

// ──────────────────────────────────────────────────────────────
//  Component
// ──────────────────────────────────────────────────────────────

const Turnover = () => {
  const [turnoverData, setTurnoverData] = useState({
    active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
    completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
  })

  const [wagerInfo, setWagerInfo] = useState({
    wager: 0,
    total_deposit: 0,
    target: 0,
    percentage: 0,
    eligible: false,
  })
  const [loadingWager, setLoadingWager] = useState(true)

  useEffect(() => {
    setTurnoverData({
      active: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
      completed: { total: 0, today: 0, thisWeek: 0, thisMonth: 0 },
    })

    const fetchWager = async () => {
      setLoadingWager(true)
      try {
        const uid = getUID ? getUID() : null
        const token = storage.getKey("token")
        if (!uid || !token) {
          setWagerInfo({ wager: 0, total_deposit: 0, target: 0, percentage: 0, eligible: false })
        } else {
          const url = `https://api.ibitplay.com/check-wager/${uid}`
          const res = await axios.get(url, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })

          const data = res.data || {}
          setWagerInfo({
            wager: Number(data.wager || 0),
            total_deposit: Number(data.total_deposit || 0),
            target: Number(data.target || 0),
            percentage: Number(data.percentage || 0),
            eligible: Boolean(data.eligible),
          })
        }
      } catch (err) {
        console.error("Failed to fetch wager info", err)
        setWagerInfo({ wager: 0, total_deposit: 0, target: 0, percentage: 0, eligible: false })
      } finally {
        setLoadingWager(false)
      }
    }

    fetchWager()
  }, [])

  const getCurrentData = () => turnoverData.active
  const hasData = () => {
    const data = getCurrentData()
    return data.total > 0 || data.today > 0 || data.thisWeek > 0 || data.thisMonth > 0
  }

  const progressPct = Math.min(100, Math.round(wagerInfo.percentage))

  return (
    <Container>
      <Helmet>
        <title>Turnover - Crypto Casino Games</title>
        <meta name="description" content="Track your turnover and betting activity" />
      </Helmet>

      <Header>
        <Title>
          <TitleIcon>
            <TrendingUp size={24} />
          </TitleIcon>
          Turnover
        </Title>
      </Header>

      <WagerTableWrapper>
        <WagerTable>
          <WagerTHead>
            <tr>
              <WagerTH>Wager Metric</WagerTH>
              <WagerTH>Value</WagerTH>
              <WagerTH style={{ width: "100%", textAlign: "center" }}>Progress</WagerTH>
            </tr>
          </WagerTHead>
          <tbody>
            <tr>
              <WagerTD>Current Wager</WagerTD>
              <WagerTD>
                {loadingWager ? "Loading…" : wagerInfo.wager.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              </WagerTD>
              <WagerTD rowSpan={2} style={{ verticalAlign: "middle" }}>
                <div
                  style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, justifyContent: "center" }}
                >
                  <div style={{ flex: 1, minWidth: 150 }}>
                    <ProgressTrack>
                      <ProgressFill pct={progressPct} />
                    </ProgressTrack>
                  </div>
                  <ProgressLabel>{progressPct}%</ProgressLabel>
                </div>
              </WagerTD>
            </tr>

            <tr>
              <WagerTD>Required Wager</WagerTD>
              <WagerTD>
                {loadingWager ? "—" : wagerInfo.target.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              </WagerTD>
            </tr>

            <tr>
              <WagerTD>Total Deposit</WagerTD>
              <WagerTD colSpan={2}>
                {loadingWager ? "—" : wagerInfo.total_deposit.toLocaleString(undefined, { maximumFractionDigits: 2 })}
              </WagerTD>
            </tr>
          </tbody>
        </WagerTable>
      </WagerTableWrapper>

      {/* Turnover Stats */}
      <ContentArea>
        {!hasData() ? (
          <>
            <IconContainer>
              <LeftBox />
              <RightBox />
              <ConnectingArc />
            </IconContainer>
            <NoDataText>No data available</NoDataText>
          </>
        ) : (
          <StatsContainer>
            <StatCard style={{ animationDelay: "0s" }}>
              <StatLabel>Total Turnover</StatLabel>
              <StatValue>{getCurrentData().total.toLocaleString()}</StatValue>
            </StatCard>
            <StatCard style={{ animationDelay: "0.1s" }}>
              <StatLabel>Today</StatLabel>
              <StatValue>{getCurrentData().today.toLocaleString()}</StatValue>
            </StatCard>
            <StatCard style={{ animationDelay: "0.2s" }}>
              <StatLabel>This Week</StatLabel>
              <StatValue>{getCurrentData().thisWeek.toLocaleString()}</StatValue>
            </StatCard>
            <StatCard style={{ animationDelay: "0.3s" }}>
              <StatLabel>This Month</StatLabel>
              <StatValue>{getCurrentData().thisMonth.toLocaleString()}</StatValue>
            </StatCard>
          </StatsContainer>
        )}
      </ContentArea>
    </Container>
  )
}

export default Turnover
